export default "__VITE_PUBLIC_ASSET__6707884e__"